export default __webpack_public_path__ + "static/media/icon-confirm-address-details.c6530674.svg";